<template lang="html">
  <ul v-if="formattedErrors.length" class="error-list">
    <li v-for="error in formattedErrors" :key="error" class="error-message">
      {{ error }}
    </li>
  </ul>
</template>

<script>
import { pluralize } from '@/utils/case';
import { appName } from '@/constants';

export default {
  name: 'ErrorList',

  props: {
    errors: {
      type: [Array, Error],
      default: () => [],
    },
  },

  data() {
    return {
      appName,
      pluralize,
      href: window.location.href,
    };
  },

  computed: {
    formattedErrors() {
      // Make sure `this.errors` is wrapped in an array.
      const errors = this.errors instanceof Array ? this.errors : [this.errors];

      // Convert each error object to an error string.
      return errors.map((e) => e.message || e);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/mixins/unstyled-list';

.error-list {
  @include unstyled-list;

  color: map-get($colors, 'warning');
  text-align: center;
}

a {
  font-weight: map-get($font-weights, 'bold-2x');
}
</style>
